<script>
  import { ignore } from "./tools";
  import { onMount } from "svelte";
  import {External} from "../external";

  export let image = null,
    imageBase = null,
    onChange = ignore,
    enabled = true;

  let bgRule =
    "url(" + External.resources + "/images/image-avatar.png) no-repeat center center";

  let pickImage = () => {
    External.FileManager.selectFile({
      onCompleteCallback: function(fileBase, pickedFile) {
        image = pickedFile;
        imageBase = fileBase;
        refreshFile();
        onChange(imageBase, image);
      }
    });
  };

  let clearImage = () => {
    image = null;
    imageBase = null;
    refreshFile();
    onChange(imageBase, image);
  };

  let refreshFile = () => {
    if (image) {
      bgRule = 
        "#ffffff url(" +
        External.getThumbnailsFromBase(imageBase, "240x160") +
        image +
        ") no-repeat center center";
    } else {
      bgRule =
        "url(" +
        External.resources +
        "/images/image-avatar.png) no-repeat center center";
    }
  };

  onMount(() => {
    refreshFile();
  });
</script>

<a
  class="add-image col-20 f-left mt-15"
  on:click={enabled ? pickImage : ignore}
  style="background: {bgRule}">
  {#if !image}
    <span class="add-button transition-all" />
  {:else}
    <span
      class="remove-button transition-all"
      on:click|stopPropagation|preventDefault={clearImage} />
  {/if}
</a>
